let { toggleFilterType } = require('../../../../../../signals/custom-order/rubrics');
let css = require('./filter-by-list.css');
let { cut } = require('../../../../../../helpers/utils');
let SELECTOR_TOGGLE_FILTER_TYPE = cut(css.button);

class Tooltip {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        return {
            click: {
                [SELECTOR_TOGGLE_FILTER_TYPE]: this.toggleFilterType,
            }
        };
    }

    toggleFilterType (e) {
        e.stopPropagation();
        this.$context.signal(toggleFilterType);
    }
}

module.exports = {
    constructor: Tooltip
};



// WEBPACK FOOTER //
// ./components/common/custom-order/rubrics/content/filter-by-list/index.js